import { PropsWithChildren } from 'react';
import { Union } from 'ts-toolbelt';

import { FieldConfig } from './WidgetField.config';

type WidgetFieldProps = {
  fieldConfig?: Union.Nullable<FieldConfig>;
} & PropsWithChildren;

export const WidgetField = ({ children, fieldConfig }: WidgetFieldProps) => {
  if (fieldConfig?.hidden) return null;

  return children;
};
